import { Paragraph } from "../basic/title";

export default function OrderDetailsList({ ordersitem }) {
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const dateObj = new Date(dateString);
        return dateObj.toLocaleDateString('en-US', options);
    };

    // Helper to safely extract variant value (like weight, size etc.)
    const getVariantValue = (item) => {
        try {
            const variants = typeof item.selected_variants === 'string'? JSON.parse(item.selected_variants): item.selected_variants;
            if(Array.isArray(variants)) {
                return variants.map(v => v?.value).join(', ');
            } else {
                return Object.values(variants).map(v => v?.value).join(', ');
            }
        } catch {
            return '';
        }
    };

    const getItemPrice = (item) => {
        const basePrice = parseFloat(item?.price || 0);
        const discount = item?.discount !== null && item?.discount !== undefined
            ? parseFloat(item.discount)
            : null;
    
        return {
            unitPrice: discount ?? basePrice,
            originalPrice: basePrice
        };
    };


    return (
        <div className="overflow-x-auto">
            <table className="table-auto min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">SKU</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Product Name</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Variants</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Qty</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Shipped</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Price</th>
                        <th className="py-3 pr-3 text-left font-dm text-[#072320] uppercase text-lg font-medium">Total</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {ordersitem?.items?.map((item, index) => {
                        const quantity = parseInt(item?.quantity || 1);
                        const { unitPrice, originalPrice } = getItemPrice(item);
                        const totalPrice = unitPrice * quantity;
                        const variantText = getVariantValue(item);

                        return (
                            <tr key={index} className={index % 2 === 0 ? 'bg-white border-b border-gray-200' : 'bg-gray-100 border-b border-gray-200'}>
                                <td className="py-4 pr-3 whitespace-nowrap">
                                    <Paragraph title={item?.product_id} textAlign='left' />
                                </td>
                                <td className="py-4 pr-3">
                                    <Paragraph title={item?.product_name} textAlign='left' />
                                </td>
                                <td className="py-4 pr-3">
                                    <Paragraph title={variantText} textAlign="left" />
                                </td>
                                <td className="py-4 whitespace-nowrap pr-3">
                                    <Paragraph title={quantity} textAlign='left' />
                                </td>
                                <td className="py-4 whitespace-nowrap pr-3">
                                    <Paragraph title='0' textAlign='left' />
                                </td>
                                <td className="py-4 whitespace-nowrap pr-3">
                                    <div className="flex flex-col text-left">
                                        {unitPrice !== originalPrice ? (
                                            <>
                                                <span className="text-sm text-gray-500 line-through">₹ {originalPrice.toFixed(2)}</span>
                                                <span className="text-base text-green-600 font-medium">₹ {unitPrice.toFixed(2)}</span>
                                            </>
                                        ) : (
                                            <span className="text-base text-gray-900">₹ {unitPrice.toFixed(2)}</span>
                                        )}
                                    </div>
                                </td>

                                <td className="py-4 whitespace-nowrap pr-3">
                                    <Paragraph title={`₹ ${totalPrice.toFixed(2)}`} textAlign='left' />
                                </td>
                            </tr>
                        );
                    })}

                    {/* Order Summary */}
                    <tr className="border-b border-gray-200">
                        <td className="py-4 whitespace-nowrap pr-3 text-right" colSpan="6">
                            <Paragraph title="Subtotal" textAlign='right' />
                        </td>
                        <td className="py-4 whitespace-nowrap pr-3">
                            <Paragraph title={`₹ ${ordersitem?.subtotal}`} textAlign='left' />
                        </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                        <td className="py-4 whitespace-nowrap pr-3 text-right" colSpan="6">
                            <Paragraph title="Shipping" textAlign='right' />
                        </td>
                        <td className="py-4 whitespace-nowrap pr-3">
                            <Paragraph title={`₹ ${ordersitem?.shipping}`} textAlign='left' />
                        </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                        <td className="py-4 whitespace-nowrap pr-3 text-right" colSpan="6">
                            <Paragraph title="Tax" textAlign='right' />
                        </td>
                        <td className="py-4 whitespace-nowrap pr-3">
                            <Paragraph title={`₹ ${ordersitem?.tax}`} textAlign='left' />
                        </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                        <td className="py-4 whitespace-nowrap pr-3 text-right" colSpan="6">
                            <Paragraph title="Total" textAlign='right' />
                        </td>
                        <td className="py-4 whitespace-nowrap pr-3">
                            <Paragraph title={`₹ ${ordersitem?.total}`} textAlign='left' />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
